import styled from 'styled-components'

import { CircleCheck, TypeStyle } from '@syconium/little-miss-figgy'

export const ReviewSummaryContainer = styled.div`
  margin-top: ${o => o.theme.spacing(6)};
`

export const ReviewSummaryHeader = styled.div`
  display: flex;
  gap: ${o => o.theme.spacing(1)};
  align-items: center;
  margin-bottom: ${o => o.theme.spacing(2)};
`

export const ReviewSummaryHeaderTitle = styled(TypeStyle.HeadlineExtraSmall)`
  font-size: 18px;
`

export const ReviewSummaryTag = styled.span`
  display: flex;
  align-items: center;
  gap: ${o => o.theme.spacing(2)};
  text-transform: capitalize;
  margin-bottom: ${o => o.theme.spacing(2)};
`

export const GreenCheck = styled(CircleCheck)`
  circle {
    fill: ${o => o.theme.color.fill.celebratory.strong};
  }
  path {
    fill: ${o => o.theme.color.fill.background};
  }
`

export const ReviewSummaryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${o => o.theme.spacing(4)};
`
